import { Box, Text } from '@mantine/core';

export const AmountBasisPill = ({ label }: { label: string }) => (
  <Box
    px={6}
    py={2}
    style={{
      alignSelf: 'flex-start',
      borderRadius: 4,
      backgroundColor: 'var(--color-bg-surface-3)'
    }}
  >
    <Text
      fz={10}
      fw={500}
      lh="normal"
      style={{ whiteSpace: 'nowrap', color: 'var(--color-text-muted)' }}
    >
      {label}
    </Text>
  </Box>
);
